export var showErrors = function showErrors(touched, error) {
  return touched && typeof error !== 'undefined';
};